import { API } from '.';
import QueryString from 'qs';

const CURRICULUM_PAGE_SIZE = 1000;
const CURRICULUM_MAX_PAGES = 100;

class CadiCurriculumService {
    async list() {
        try {
            const curriculums = [];
            let page = 1;
            let pageCount = 1;

            while (page <= pageCount) {
                const query = QueryString.stringify(
                    {
                        fields: ['id', 'cadiId', 'code', 'title'],
                        filters: { isActive: { $eq: true } },
                        pagination: {
                            page,
                            pageSize: CURRICULUM_PAGE_SIZE,
                        },
                        sort: ['title:asc'],
                    },
                    { encodeValuesOnly: true },
                );
                const response = await API.get(
                    `/api/cadi-curriculums?${query}`,
                );
                curriculums.push(...(response.data.data ?? []));
                const nextPageCount =
                    response.data.meta?.pagination?.pageCount ?? 1;
                if (
                    !Number.isInteger(nextPageCount) ||
                    nextPageCount < 1 ||
                    nextPageCount > CURRICULUM_MAX_PAGES
                ) {
                    throw new Error('Invalid curriculum pagination response');
                }
                pageCount = nextPageCount;
                page += 1;
            }

            return curriculums;
        } catch (error) {
            console.log(error);
            return null;
        }
    }

    async sync() {
        try {
            const response = await API.post('/api/cadi-curriculums/sync');
            return response.data;
        } catch (error) {
            console.log(error);
            return null;
        }
    }

    async addJobMapping(curriculumId, jobId) {
        try {
            const response = await API.post(
                `/api/cadi-curriculums/${curriculumId}/jobs/${jobId}`,
            );
            return { data: response.data };
        } catch (error) {
            console.log(error);
            return { error: error.response?.data?.error?.message ?? null };
        }
    }

    async removeJobMapping(curriculumId, jobId) {
        try {
            const response = await API.delete(
                `/api/cadi-curriculums/${curriculumId}/jobs/${jobId}`,
            );
            return response.data;
        } catch (error) {
            console.log(error);
            return null;
        }
    }
}

export default CadiCurriculumService;
